export default function sortNewsByDate(news) {
  return [...news].sort((a, b) => {
    const aTime = Date.parse(a?.fields?.Date ?? "");
    const bTime = Date.parse(b?.fields?.Date ?? "");
    const normalizedATime = Number.isNaN(aTime) ? Number.NEGATIVE_INFINITY : aTime;
    const normalizedBTime = Number.isNaN(bTime) ? Number.NEGATIVE_INFINITY : bTime;

    return normalizedBTime - normalizedATime;
  });
}
